import { Navigate, useParams } from 'react-router-dom';
import { LayoutPageTitle, LayoutBreadcrumbs } from '@/features/layout';
import { useGetTemplateQuery } from '@/state/slices/reports';
import { TemplateEditor } from '@/features/template-manager';

export default function TemplateEditorPage() {
  const { uuid } = useParams<{ uuid: string }>();
  const { data: template } = useGetTemplateQuery(uuid ?? '', {
    skip: !uuid,
  });

  if (!uuid) return <Navigate to="/templates/templates" replace />;

  return (
    <>
      <LayoutPageTitle title="Edit Report Template" />
      <LayoutBreadcrumbs
        items={[
          { label: 'Templates', to: '/templates/templates' },
          { label: template?.name ?? 'Loading...' },
        ]}
      />
      <TemplateEditor uuid={uuid} />
    </>
  );
}
